// extracted by mini-css-extract-plugin
var _1 = "InputWrapLabel-moduleInputWrapLabel__sI90S";
var _2 = "InputWrapLabel-moduledisabled__sL8mE";
export { _1 as "InputWrapLabel", _2 as "disabled" }
